module.exports = __webpack_public_path__ + "7444fcd66370a3b08bb9fe1c3e1767fd.pdf";